import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "create-ticket-header" }
const _hoisted_2 = { class: "create-ticket-header__title" }
const _hoisted_3 = { class: "create-ticket-header__buttons" }

import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'

interface EMITS {
  (e: 'closeCreateTicketModal', value: boolean): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTicketHeader',
  props: {
    title: {}
  },
  emits: ["closeCreateTicketModal"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

function closeModal() {
  emits('closeCreateTicketModal', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(props.title), 1),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(ButtonText, {
        class: "create-ticket-header__buttons__button",
        iconLeft: require('@/design-system/assets/icons/Icon-X-Small.svg'),
        size: "extra-small",
        onOnClicked: closeModal
      }, null, 8, ["iconLeft"])
    ])
  ]))
}
}

})